import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { UmsService } from '../ums.service';
import * as moment from 'moment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-theory-exam-appointment',
  templateUrl: './theory-exam-appointment-component.component.html',
  styleUrls: ['./theory-exam-appointment-component.component.scss']
})
export class TheoryExamAppointmentComponent implements OnInit {
  TheoryExamForm: FormGroup;
  
  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  facultyList: any[] = [];
  filteredFacultyList: any[] = [];
  courseLevelList: any[] = [];
  filteredCourseLevelList: any[] = [];
  courseList: any[] = [];
  filteredCourseList: any[] = [];
  examList: any[] = [];
  filteredExamList: any[] = [];
  collegeList: any[] = [];
  filteredCollegeList: any[] = [];
  teacherList: any[] = [];
  filteredTeacherList: any[] = [];
  roleList: any[] = [];
  filteredRoleList: any[] = [];
  isTimetableAvailable: boolean = false;
  examTimeData: any[] = [];
  teacherAppointments: any[] = [];
  Table = false;
  showTeacherDropdown: boolean = true;
  editingAppointmentId: number = null;
  editingRoleId: number = null;
  public isLoadingTeachers: boolean = false;
  private teachersCache: Map<string, any[]> = new Map();
  private examCache = new Map<string, any[]>();      
  originalApptType: string = 'R';
  isDateManuallyChanged: boolean = false;
  minExamDate: Date = null;
  maxExamDate: Date = null;
  private deletingInProgress: boolean = false;
  private roleChangeTimeout: any;
  private isFetchingAppointments: boolean = false;
  private invigilatorSquadMap: Map<number, number> = new Map(); 
  private selectedInvigilators: Map<number, number> = new Map();
  isFinalSubmitted: boolean = false; 
  private isSaving: boolean = false;
  dialogRef: MatDialogRef<any>;
  selectedAppointments: any[] = [];   // stores selected items
  private isProcessingBulk = false;    // prevent multiple clicks
  
  constructor(
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.fetchSession();
    this.fetchRoles();
    this.fetchCourseLevel();
    this.showTeacherDropdown = true; 
    this.checkFinalSubmissionStatus();
  }


  initializeForm() {
    this.TheoryExamForm = this.fb.group({
      SessionId: ['', Validators.required],
      FacultyId: [[]],
      CourseLevel: [[]],                     // Changed to array
      Course: [[]],                        
      Exam: [[]],                           
      Center: ['', Validators.required],
      FromDate: [''],
      ToDate: [''],
      Teacher: [''],
      Role: [''],
      ApptType: ['R']
    });
  }


  fetchSession() {
    this.spinner.show();
    const payload = { SnDefault: '', SnNo: '' };
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.sessionList = res.data.filter((el: any) => el.SnStatus === 'O');
        this.SessionFilterList = [...this.sessionList];
      }
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    });
  }

  fetchCourseLevel() {
    const payload = { CdType: 'COLVL' };
    this.umsService.getCodeType(payload).subscribe(res => {
      if (res.status && res.data) {
        this.courseLevelList = res.data;
        this.filteredCourseLevelList = [...this.courseLevelList];
      } else {
        console.warn('⚠️ No course level data received');
      }
    }, (error) => {
      console.error('❌ Error fetching course levels:', error);
    });
  }

  onApptTypeChange() {
    this.fetchAppointments();
  }

  fetchRoles() {
    this.spinner.show();
    const payload = { CdType: 'ReqTy' };  
    this.umsService.getCodeType(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data) {
        const allowedRoles = ['CI', 'CO', 'INV', 'C'];
        let filteredRoles = res.data.filter((role: any) => {
          const code = (role.CdCode || '').toUpperCase();
          return role.CdActive === 'Y' && allowedRoles.includes(code);
        });

        const hasCustodian = filteredRoles.some(r => r.CdCode.toUpperCase() === 'C');
        if (!hasCustodian) {
          filteredRoles.push({
            CdCode: 'C',
            CdDesc: 'Custodian',
            CdActive: 'Y'
          });
        }

        this.roleList = filteredRoles.map((role: any) => {
          let customDisplayName = role.CdDesc;
          const code = (role.CdCode || '').toUpperCase();
          switch(code) { 
            case 'CO': customDisplayName = 'Center Observer (CO)'; break;
            case 'CI': customDisplayName = 'Center Incharge (CI)'; break;
            case 'INV': customDisplayName = 'Internal Vigilance Squad (IVS)'; break;
            case 'C':  customDisplayName = 'Custodian (C)'; break;   // New role
            default: customDisplayName = role.CdDesc;
          }
          return { ...role, CdDesc: customDisplayName };
        });
        this.filteredRoleList = [...this.roleList];
      } else {
        this.roleList = [];
        this.filteredRoleList = [];
      }
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.roleList = [];
      this.filteredRoleList = [];
      console.error('Error fetching roles:', error);
    });
  }


 onSessionChange(sessionId: number) {
    this.spinner.show();
    this.Table = false;
    this.resetDependentFields(['FacultyId', 'Course', 'Exam', 'Center', 'Teacher']);

    const payload = { SessionId: sessionId };
    this.umsService.getFaculty(payload).subscribe(res => {
        this.spinner.hide();
        if (res.status && res.data) {
            this.facultyList = res.data;
            this.filteredFacultyList = [...this.facultyList];
        } else {
            this.facultyList = [];
            this.filteredFacultyList = [];
        }
    }, (error) => {
        this.spinner.hide();
        this.facultyList = [];
        this.filteredFacultyList = [];
    });

   
    this.loadCentersBySession(sessionId);
  }

  onFacultyChange(selectedFaculties: any[]) {
    this.isDateManuallyChanged = false;
    this.spinner.show();
    this.Table = false;
    this.resetDependentFields(['Course', 'Exam', 'Teacher']);
    this.minExamDate = null;
    this.maxExamDate = null;
    this.teachersCache.clear();
    this.teacherList = [];
    this.filteredTeacherList = [];

    const sessionId = this.TheoryExamForm.get('SessionId')?.value;
    if (!sessionId || !selectedFaculties || selectedFaculties.length === 0) {
      this.courseList = [];
      this.filteredCourseList = [];
      this.spinner.hide();
      return;
    }

    let actualFaculties = selectedFaculties.filter(f => f !== 'selectAll');
    if (selectedFaculties.includes('selectAll')) {
      const all = this.facultyList.map(f => f.FcCode);
      const allSelected = actualFaculties.length === all.length && all.every(c => actualFaculties.includes(c));
      actualFaculties = allSelected ? [] : all;
      this.TheoryExamForm.patchValue({ FacultyId: actualFaculties }, { emitEvent: false });
      if (actualFaculties.length === 0) {
        this.courseList = [];
        this.filteredCourseList = [];
        this.spinner.hide();
        return;
      }
    }

    const facultyCodes = actualFaculties.join(',');
    const payload = { SessionId: sessionId, FcCode: facultyCodes };
    this.umsService.getCoursesWithLevel(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status && res.data) {
          this.courseList = res.data;
          // Filter by selected course levels (array)
          const currentLevels = this.TheoryExamForm.get('CourseLevel')?.value || [];
          if (currentLevels.length > 0) {
            this.filteredCourseList = this.courseList.filter(c =>
              currentLevels.includes(c.CourseLevel?.toString().trim() || '')
            );
          } else {
            this.filteredCourseList = [...this.courseList];
          }
          this.TheoryExamForm.patchValue({ Course: [] });
        } else {
          this.courseList = [];
          this.filteredCourseList = [];
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: 'No courses found for the selected faculties.',
            title: 'Information',
            icon: 'fas fa-info-circle'
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.courseList = [];
        this.filteredCourseList = [];
        console.error('Error fetching courses:', error);
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'Error loading courses. Please try again.',
          title: 'Error',
          icon: 'fas fa-exclamation-triangle'
        });
      }
    });
  }

  // ========== UPDATED: Multi-select Course Level with Select All ==========
  onCourseLevelChange(selectedLevels: string[]) {
    const hasSelectAll = selectedLevels && selectedLevels.includes('selectAll');
    let actualLevels = selectedLevels ? selectedLevels.filter(l => l !== 'selectAll') : [];

    if (hasSelectAll) {
      const all = this.courseLevelList.map(item => item.CdCode);
      const allSelected = actualLevels.length === all.length && all.every(c => actualLevels.includes(c));
      const newSelection = allSelected ? [] : all;

      // Update form value without triggering change event again
      this.TheoryExamForm.patchValue({ CourseLevel: newSelection }, { emitEvent: false });
      actualLevels = newSelection;
    }

    // Filter courses based on selected levels (or show all if none selected)
    if (!actualLevels || actualLevels.length === 0) {
      this.filteredCourseList = [...this.courseList];
    } else {
      this.filteredCourseList = this.courseList.filter(course => {
        const courseLevel = course.CourseLevel?.toString().trim() || '';
        return actualLevels.includes(courseLevel);
      });
      if (this.filteredCourseList.length === 0) {
        console.warn('No courses match the selected levels.');
      }
    }

    // Reset dependent fields
    this.TheoryExamForm.patchValue({ Course: [] });
    if (!this.editingAppointmentId) {
      this.resetDependentFields(['Exam', 'Teacher']);
      this.teachersCache.clear();
      this.teacherList = [];
      this.filteredTeacherList = [];
    } else {
      this.resetDependentFields(['Exam']);
    }

    this.Table = false;
    this.teacherAppointments = [];
    this.examList = [];
    this.filteredExamList = [];

    if (this.TheoryExamForm.valid && this.TheoryExamForm.get('Center')?.value) {
      this.fetchAppointments();
      if (!this.editingAppointmentId) {
        this.loadTeachers();
      }
    }
  }

  onCourseChange(courseCodes: string[]) {
    const hasSelectAll = courseCodes && courseCodes.includes('selectAll');
    let actualCodes = courseCodes ? courseCodes.filter(c => c !== 'selectAll') : [];

    if (hasSelectAll) {
      const all = this.filteredCourseList.map(item => item.CoCgCoCode);
      const allSelected = actualCodes.length === all.length && all.every(c => actualCodes.includes(c));
      const newSelection = allSelected ? [] : all;

      this.TheoryExamForm.patchValue({ Course: newSelection }, { emitEvent: false });

      if (newSelection.length === 0) {
        if (!this.editingAppointmentId) {
          this.resetDependentFields(['Exam', 'Center', 'Teacher']);
        } else {
          this.resetDependentFields(['Exam']);
        }
        this.spinner.hide();
        return;
      } else {
        this.isDateManuallyChanged = false;
        this.spinner.show();
        this.Table = false;
        if (!this.editingAppointmentId) {
          this.resetDependentFields(['Exam', 'Teacher']);
        } else {
          this.resetDependentFields(['Exam']);
        }
        const formValue = this.TheoryExamForm.value;
        const selectedCourses = newSelection.join(',');
        
        const cacheKey = selectedCourses;
        if (this.examCache.has(cacheKey)) {
          this.examList = this.examCache.get(cacheKey)!;
          this.filteredExamList = [...this.examList];
          this.spinner.hide();
          if (this.TheoryExamForm.get('Center')?.value && this.TheoryExamForm.valid) {
            this.fetchAppointments();
          }
          return;
        }

        const examPayload = {
          EmCoCode: selectedCourses,
          EmId: 0,
          CgCode: '',
          SearchString: '',
          PageSize: 1000,
          PageNumber: 1
        };
        this.umsService.getExam(examPayload).subscribe({
          next: (res) => {
            this.spinner.hide();
            if (res.status && res.data && res.data.length > 0) {
              this.examList = res.data;
              this.filteredExamList = [...this.examList];
              this.examCache.set(cacheKey, res.data);
            } else {
              this.examList = [];
              this.filteredExamList = [];
            }
            if (this.TheoryExamForm.get('Center')?.value && this.TheoryExamForm.valid) {
              this.fetchAppointments();
            }
          },
          error: (error) => {
            this.spinner.hide();
            this.examList = [];
            this.filteredExamList = [];
            console.error('Error fetching exams:', error);
          }
        });
        return;
      }
    }

    this.isDateManuallyChanged = false;
    if (!courseCodes || courseCodes.length === 0) {
      if (!this.editingAppointmentId) {
        this.resetDependentFields(['Exam', 'Center', 'Teacher']);
      } else {
        this.resetDependentFields(['Exam']);
      }
      this.spinner.hide();
      return;
    }

    this.spinner.show();
    this.Table = false;

    if (!this.editingAppointmentId) {
      this.resetDependentFields(['Exam', 'Teacher']);
    } else {
      this.resetDependentFields(['Exam']);
    }
    const formValue = this.TheoryExamForm.value;
    const selectedCourses = courseCodes.join(',');

    const cacheKey = selectedCourses;
    if (this.examCache.has(cacheKey)) {
      this.examList = this.examCache.get(cacheKey)!;
      this.filteredExamList = [...this.examList];
      this.spinner.hide();
      if (this.TheoryExamForm.get('Center')?.value && this.TheoryExamForm.valid) {
        this.fetchAppointments();
        if (!this.editingAppointmentId) {
          this.loadTeachers();
        }
      }
      return;
    }

    const examPayload = {
      EmCoCode: selectedCourses,
      EmId: 0,
      CgCode: '',
      SearchString: '',
      PageSize: 1000,
      PageNumber: 1
    };
    this.umsService.getExam(examPayload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status && res.data && res.data.length > 0) {
          this.examList = res.data;
          this.filteredExamList = [...this.examList];
          this.examCache.set(cacheKey, res.data);
        } else {
          this.examList = [];
          this.filteredExamList = [];
        }
        if (this.TheoryExamForm.get('Center')?.value && this.TheoryExamForm.valid) {
          this.fetchAppointments();
          if (!this.editingAppointmentId) {
            this.loadTeachers();
          }
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.examList = [];
        this.filteredExamList = [];
        console.error('Error fetching exams:', error);
      }
    });
  }

  onExamChange(examIds: any[]) {
    const hasSelectAll = examIds && examIds.includes('selectAll');
    let actualIds = examIds ? examIds.filter(id => id !== 'selectAll') : [];

    if (hasSelectAll) {
      const all = this.filteredExamList.map(item => item.EmId);
      const allSelected = actualIds.length === all.length && all.every(id => actualIds.includes(id));
      const newSelection = allSelected ? [] : all;

      this.TheoryExamForm.patchValue({ Exam: newSelection }, { emitEvent: false });

      if (newSelection.length === 0) {
        if (!this.editingAppointmentId) {
          this.resetDependentFields(['Center', 'Teacher']);
        } else {
          this.resetDependentFields([]); 
        }
        this.spinner.hide();
        this.Table = false;
        this.teacherAppointments = [];
        return;
      } else {
        this.isDateManuallyChanged = false;
        this.spinner.show();
        this.Table = false;
        if (!this.editingAppointmentId) {
          this.resetDependentFields(['Center', 'Teacher']);
        } else {
          this.resetDependentFields([]);
        }
        const formValue = this.TheoryExamForm.value;
        if (formValue.Center && this.TheoryExamForm.valid) {
          this.fetchAppointments();
        } else {
          this.spinner.hide();
        }
        return;
      }
    }

    this.isDateManuallyChanged = false;
    if (!examIds || examIds.length === 0) {
      if (!this.editingAppointmentId) {
        this.resetDependentFields(['Center', 'Teacher']);
      } else {
        this.resetDependentFields([]);
      }
      this.spinner.hide();
      this.Table = false;
      this.teacherAppointments = [];
      return;
    }

    this.spinner.show();
    this.Table = false;

    if (!this.editingAppointmentId) {
      this.resetDependentFields(['Center', 'Teacher']);
    } else {
      this.resetDependentFields([]);
    }
    const formValue = this.TheoryExamForm.value;
    if (formValue.Center && this.TheoryExamForm.valid) {
      this.fetchAppointments();
    } else {
      this.spinner.hide();
    }
  }

  loadCentersBySession(sessionId: number) {
    this.spinner.show();
    const payload = { SessionId: sessionId };
    this.umsService.getCentresFromAllocation(payload).subscribe({
        next: (res) => {
            this.spinner.hide();
            if (res.status && res.data && res.data.length > 0) {
                this.collegeList = res.data.map((item: any) => ({
                    CgCode: item.CgCode,
                    CgName: item.CgName,
                    DistrictName: item.DistrictName
                }));
                this.filteredCollegeList = [...this.collegeList];
                this.TheoryExamForm.patchValue({ Center: '' });
            } else {
                this.collegeList = [];
                this.filteredCollegeList = [];
                this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                    message: 'No centres found for this session',
                    title: 'Information',
                    icon: 'fas fa-info-circle'
                });
                this.TheoryExamForm.patchValue({ Center: '' });
            }
        },
        error: (error) => {
            this.spinner.hide();
            this.collegeList = [];
            this.filteredCollegeList = [];
            console.error('Error fetching centers:', error);
        }
    });
  }

  onFromDateChange() {
    this.isDateManuallyChanged = true;
    const fromDate = this.TheoryExamForm.get('FromDate').value;
    if (!fromDate) return;
    const from = moment(fromDate);
    if (this.minExamDate && this.maxExamDate) {
      const min = moment(this.minExamDate);
      const max = moment(this.maxExamDate);
      if (from.isBefore(min)) {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: `From Date cannot be before ${min.format('DD/MM/YYYY')}`,
          title: 'Date Validation',
          icon: 'fas fa-exclamation-triangle'
        });
        this.TheoryExamForm.patchValue({ FromDate: min.format('YYYY-MM-DD') });
        return;
      }
      if (from.isAfter(max)) {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: `From Date cannot be after ${max.format('DD/MM/YYYY')}`,
          title: 'Date Validation',
          icon: 'fas fa-exclamation-triangle'
        });
        this.TheoryExamForm.patchValue({ FromDate: max.format('YYYY-MM-DD') });
        return;
      }
    }
    const toDate = this.TheoryExamForm.get('ToDate').value;
    if (toDate) {
      const to = moment(toDate);
      if (from.isAfter(to)) {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'From Date cannot be after To Date',
          title: 'Date Validation',
          icon: 'fas fa-exclamation-triangle'
        });
        this.TheoryExamForm.patchValue({ FromDate: to.format('YYYY-MM-DD') });
        return;
      }
    }
  }

  onToDateChange() {
    this.isDateManuallyChanged = true;
    const toDate = this.TheoryExamForm.get('ToDate').value;
    if (!toDate) return;
    const to = moment(toDate);
    if (this.minExamDate && this.maxExamDate) {
      const min = moment(this.minExamDate);
      const max = moment(this.maxExamDate);
      if (to.isBefore(min)) {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: `To Date cannot be before ${min.format('DD/MM/YYYY')}`,
          title: 'Date Validation',
          icon: 'fas fa-exclamation-triangle'
        });
        this.TheoryExamForm.patchValue({ ToDate: min.format('YYYY-MM-DD') });
        return;
      }
      if (to.isAfter(max)) {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: `To Date cannot be after ${max.format('DD/MM/YYYY')}`,
          title: 'Date Validation',
          icon: 'fas fa-exclamation-triangle'
        });
        this.TheoryExamForm.patchValue({ ToDate: max.format('YYYY-MM-DD') });
        return;
      }
    }
    const fromDate = this.TheoryExamForm.get('FromDate').value;
    if (fromDate) {
      const from = moment(fromDate);
      if (from.isAfter(to)) {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'From Date cannot be after To Date',
          title: 'Date Validation',
          icon: 'fas fa-exclamation-triangle'
        });
        this.TheoryExamForm.patchValue({ FromDate: to.format('YYYY-MM-DD') });
        return;
      }
    }
  }

  onCenterChange(centerCode: string) {
    if (this.isFinalSubmitted) return;
    if (this.TheoryExamForm.valid) {
      if (!this.editingAppointmentId) {
        this.TheoryExamForm.patchValue({ Teacher: '' });
        this.teacherList = [];
        this.filteredTeacherList = [];
      }
      this.fetchAppointments();
      const formValue = this.TheoryExamForm.value;
      if (formValue.SessionId && formValue.Course && formValue.Exam && centerCode && formValue.Role) {
        if (!this.editingAppointmentId) {
          this.loadTeachers();
        }
      }
    }
  }

  onTeacherChange(teacherId: number) {
    if (!teacherId) return;
    if (this.TheoryExamForm.valid) {
      this.fetchAppointments();
    }
  }

  onRoleChange(roleCode: string) {
    if (this.isFinalSubmitted) return;
    if (!roleCode) return;
    if (this.roleChangeTimeout) clearTimeout(this.roleChangeTimeout);
    this.TheoryExamForm.patchValue({ Role: roleCode });

    if (!this.editingAppointmentId) {
      this.TheoryExamForm.patchValue({ Teacher: '' });
      this.teacherList = [];
      this.filteredTeacherList = [];
    }
    this.roleChangeTimeout = setTimeout(() => {
      const formValue = this.TheoryExamForm.value;
      if (formValue.SessionId && formValue.Course && formValue.Exam && formValue.Center) {
        this.fetchAppointments();
        if (!this.editingAppointmentId) {
          this.loadTeachers();
        }
      }
    }, 500);
  }

  loadTeachers(callback?: (success: boolean) => void) {
    if (this.isFinalSubmitted) {
      this.teacherList = [];
      this.filteredTeacherList = [];
      if (callback) callback(false);
      return;
    }
    const formValue = this.TheoryExamForm.value;
    if (!formValue.SessionId || !formValue.Center || !formValue.Role) {
      this.teacherList = [];
      this.filteredTeacherList = [];
      if (callback) callback(false);
      return;
    }
    const selectedCourses = formValue.Course || [];
    const selectedExams = formValue.Exam || [];

    const cacheKey = `${formValue.SessionId}_${selectedCourses.join(',')}_${selectedExams.join(',')}_${formValue.Center}_${formValue.Role}`;
    if (this.teachersCache.has(cacheKey)) {
      this.teacherList = this.teachersCache.get(cacheKey)!;
      this.filteredTeacherList = [...this.teacherList];
      if (callback) callback(true);
      return;
    }
    if (this.isLoadingTeachers) {
      if (callback) callback(false);
      return;
    }
    this.isLoadingTeachers = true;
    this.spinner.show();

    const payload = {
      SessionId: formValue.SessionId,
      CourseCode: selectedCourses.join(','),
      ExamId: selectedExams.join(','),
      CenterCode: formValue.Center,
      RoleCode: formValue.Role
    };

    this.umsService.getTeachersViaUnified(payload).subscribe({
      next: (res) => {
        this.isLoadingTeachers = false;
        this.spinner.hide();
        if (res.status && res.data && res.data.length > 0) {
          const teachers = res.data.map((teacher: any) => {
            let teacherName = teacher.TeacherName || 
              `${teacher.Initial || ''} ${teacher.FirstName || ''} ${teacher.MiddleName || ''} ${teacher.LastName || ''}`.trim();
            teacherName = teacherName.replace(/\s+/g, ' ').trim();
            let genderSuffix = '';
            let gender = (teacher.Gender || '').toString().toUpperCase();
            if (gender === 'M' || gender === 'MALE') genderSuffix = 'M';
            else if (gender === 'F' || gender === 'FEMALE') genderSuffix = 'F';
            let displayName = teacherName;
            let squadNumber = null;
            let isAssigned = false;
            const currentRole = this.TheoryExamForm.value.Role;
            if (currentRole === 'CO') {
              isAssigned = this.teacherAppointments.some(app => app.RoleCode === 'CO' && app.TechId === teacher.TechId);
              if (teacher.CollegeRelation === 'DIFFERENT' && teacher.HomeCollegeName) {
                displayName = `${teacherName} (${teacher.HomeCollegeName})`;
              } else {
                displayName = teacherName;
              }
              if (isAssigned) displayName = `✓ ${displayName}`;
            } else if (currentRole === 'CI') {
              isAssigned = this.teacherAppointments.some(app => app.RoleCode === 'CI' && app.TechId === teacher.TechId);
              if (teacher.CollegeRelation === 'SAME' && teacher.HomeCollegeName) {
                displayName = `${teacherName} (${teacher.HomeCollegeName})`;
              } else {
                displayName = teacherName;
              }
              if (isAssigned) displayName = `✓ ${displayName}`;
            } else if (currentRole === 'INV') {
              isAssigned = this.teacherAppointments.some(app => app.RoleCode === 'INV' && app.TechId === teacher.TechId);
              if (isAssigned) {
                const existingApp = this.teacherAppointments.find(app => app.RoleCode === 'INV' && app.TechId === teacher.TechId);
                squadNumber = existingApp?.SquadNumber;
                displayName = `✓ ${teacherName}`;
              } else {
                displayName = teacherName;
                squadNumber = null;
              }
              if (teacher.CollegeRelation === 'SAME' && teacher.HomeCollegeName) {
                displayName = `${displayName} (${teacher.HomeCollegeName})`;
              }
            } else if (currentRole === 'C') { 
              isAssigned = this.teacherAppointments.some(app => app.RoleCode === 'C' && app.TechId === teacher.TechId);
              if (isAssigned) {
                displayName = `✓ ${teacherName}`;
              } else {
                displayName = teacherName;
              }
            }
            if (genderSuffix && !displayName.includes(` - ${genderSuffix}`)) {
              displayName = `${displayName} - ${genderSuffix}`;
            }

            const displayNameWithoutGender = displayName.replace(/\s*-\s*[MF]\s*$/, '').trim();

            return {
              ...teacher,
              displayName: displayName,
              displayNameWithoutGender: displayNameWithoutGender,   
              teacherName: teacherName,
              genderSuffix: genderSuffix,
              isAssigned: isAssigned,
              squadNumber: squadNumber
            };
          });
          this.teachersCache.set(cacheKey, teachers);
          this.teacherList = teachers;
          this.filteredTeacherList = [...teachers];
          if (callback) callback(true);
        } else {
          this.teacherList = [];
          this.filteredTeacherList = [];
          if (callback) callback(false);
        }
      },
      error: (err) => {
        this.isLoadingTeachers = false;
        this.spinner.hide();
        this.teacherList = [];
        this.filteredTeacherList = [];
        if (callback) callback(false);
        console.error('API Error:', err);
      }
    });
  }

  getSquadNumber(techId: number): number {
    if (this.selectedInvigilators && this.selectedInvigilators.has(techId)) {
      return this.selectedInvigilators.get(techId);
    }
    return null;
  }

  trackTeacherById(index: number, item: any) {
    return item.TechId;
  }

  fetchAppointments() {
    const formValue = this.TheoryExamForm.value;  

    if (!formValue.SessionId || !formValue.Center) {
      this.teacherAppointments = [];   
      this.Table = false;              
      return;
    }

    this.spinner.show();

    const selectedCourses = formValue.Course || [];
    const selectedExams = formValue.Exam || [];
    const selectedFaculties = formValue.FacultyId || [];
    const selectedLevels = formValue.CourseLevel || [];

    const payload: any = {
      SessionId: formValue.SessionId,
      CenterCode: formValue.Center
    };

    if (selectedFaculties.length > 0) payload.FacultyId = selectedFaculties.join(',');
    if (selectedLevels.length > 0) payload.CourseLevel = selectedLevels.join(','); // send as comma-separated
    if (selectedCourses.length > 0) payload.CourseCode = selectedCourses.join(',');
    if (selectedExams.length > 0) payload.ExamId = selectedExams.join(',');
    if (formValue.Role) payload.RoleCode = formValue.Role;
    if (formValue.ApptType) payload.ApptType = formValue.ApptType;

  console.log('📤 Fetching appointments payload:', payload);

  this.umsService.getTeacherAppointments(payload).subscribe({
    next: (res: any) => {
      this.spinner.hide();
      console.log('📥 Full API Response:', res);
      
      if (res.status && res.data && res.data.length > 0) {
        this.teacherAppointments = res.data;
        this.Table = true;  // Show the table
        console.log('✅ Appointments loaded:', this.teacherAppointments.length);
      } else {
        this.teacherAppointments = [];
        // Keep the table visible if we want to show "No appointments" message
        this.Table = true;
        console.warn('⚠️ No appointments found');
      }
    },
    error: (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.teacherAppointments = [];
      // Keep table visible to show error state
      this.Table = true;
      console.error('❌ Error fetching appointments:', error);
    }
  });
}

  resetDependentFields(fields: string[]) {
    fields.forEach(field => {
      if (field === 'Course' || field === 'Exam') {
        this.TheoryExamForm.get(field)?.setValue([]);
      } else if (field === 'FacultyId') {
        this.TheoryExamForm.get(field)?.setValue([]);
      } else {
        this.TheoryExamForm.get(field)?.setValue('');
      }
      this.TheoryExamForm.get(field)?.updateValueAndValidity();
    });
  }


  // onSave() {
  //   if (this.isFinalSubmitted === true) {
  //     this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //       message: 'Cannot save. This schedule is already finalized.',
  //       title: 'Locked',
  //       icon: 'fas fa-lock'
  //     });
  //     return;
  //   }
  //   if (this.isSaving) return;

  //   const formValue = this.TheoryExamForm.value;

  //   if (!formValue.Teacher || !formValue.Role) {
  //     this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //       message: 'Please select Teacher and Role before saving.',
  //       title: 'Validation Error',
  //       icon: 'fas fa-exclamation-triangle'
  //     });
  //     return;
  //   }

  //   if (!formValue.FromDate || !formValue.ToDate) {
  //     this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //       message: 'Please select From Date and To Date.',
  //       title: 'Validation Error',
  //       icon: 'fas fa-exclamation-triangle'
  //     });
  //     return;
  //   }

  //   const fromDate = moment(formValue.FromDate);
  //   const toDate = moment(formValue.ToDate);
  //   if (fromDate.isAfter(toDate)) {
  //     this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //       message: 'From Date cannot be after To Date.',
  //       title: 'Date Validation',
  //       icon: 'fas fa-exclamation-triangle'
  //     });
  //     return;
  //   }

  //   let updatedAppointments = [...this.teacherAppointments];
  //   const selectedRole = formValue.Role;
  //   const selectedTeacher = formValue.Teacher;

  //   if (selectedRole === 'CO') {
  //     const existingCO = updatedAppointments.find(a => a.RoleCode === 'CO' && a.AppointmentId !== this.editingAppointmentId);
  //     if (existingCO) {
  //       this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //         message: `A Center Observer (CO) is already appointed (${existingCO.TeacherName}). Only one CO is allowed.`,
  //         title: 'Duplicate Role',
  //         icon: 'fas fa-exclamation-triangle'
  //       });
  //       return;
  //     }
  //   }
  //   if (selectedRole === 'CI') {
  //     const existingCI = updatedAppointments.find(a => a.RoleCode === 'CI' && a.AppointmentId !== this.editingAppointmentId);
  //     if (existingCI) {
  //       this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //         message: `A Center Incharge (CI) is already appointed (${existingCI.TeacherName}). Only one CI is allowed.`,
  //         title: 'Duplicate Role',
  //         icon: 'fas fa-exclamation-triangle'
  //       });
  //       return;
  //     }
  //   }

  //   let existingIndex = -1;
  //   if (selectedRole === 'CO' || selectedRole === 'CI') {
  //     existingIndex = updatedAppointments.findIndex(a => a.RoleCode === selectedRole);
  //   }
  //   if (selectedRole === 'INV' && this.editingRoleId) {
  //     existingIndex = updatedAppointments.findIndex(a => a.RoleId === this.editingRoleId);
  //   }
  //   if (existingIndex !== -1 && this.editingAppointmentId) {
  //     updatedAppointments[existingIndex] = {
  //       ...updatedAppointments[existingIndex],
  //       TechId: selectedTeacher,
  //       FromDate: formValue.FromDate,
  //       ToDate: formValue.ToDate
  //     };
  //   } else {
  //     updatedAppointments.push({
  //       RoleId: 0,
  //       RoleCode: selectedRole,
  //       TechId: selectedTeacher,
  //       FromDate: formValue.FromDate,
  //       ToDate: formValue.ToDate
  //     });
  //   }

  //   // Get Faculty Code from selected courses
  //   let facultyIdForSave = '';
  //   const selectedCourses = formValue.Course || [];
  //   if (selectedCourses.length > 0) {
  //     // Get unique faculty codes from selected courses
  //     const facultyCodeSet = new Set<string>();
  //     selectedCourses.forEach(courseCode => {
  //       const course = this.courseList.find(c => c.CoCgCoCode === courseCode);
  //       if (course && course.FcCode) {
  //         facultyCodeSet.add(course.FcCode);
  //       }
  //     });
  //     facultyIdForSave = Array.from(facultyCodeSet).join(',');
  //   }
    
  //   // Fallback: use selected faculty IDs
  //   if (!facultyIdForSave && formValue.FacultyId && formValue.FacultyId.length > 0) {
  //     facultyIdForSave = formValue.FacultyId.join(',');
  //   }

  //   // Debug log
  //   console.log('📤 Saving with Faculty IDs:', facultyIdForSave);
  //   console.log('📤 Selected Courses:', selectedCourses);

  //   const shouldCreateNew = this.editingAppointmentId
  //                           && this.originalApptType === 'R'
  //                           && formValue.ApptType === 'X';

  //   const appointmentPayload: any = {
  //     AppointmentId: shouldCreateNew ? null : this.editingAppointmentId || null,
  //     TechId: formValue.Teacher,
  //     SessionId: formValue.SessionId,
  //     FacultyId: facultyIdForSave,
  //     CourseCode: formValue.Course.join(','),
  //     ExamId: formValue.Exam.join(','),
  //     CenterCode: formValue.Center,
  //     RoleCode: formValue.Role,
  //     FromDate: moment(formValue.FromDate).format('YYYY-MM-DD'),
  //     ToDate: moment(formValue.ToDate).format('YYYY-MM-DD'),
  //     CourseLevel: formValue.CourseLevel || null,
  //     ApptType: formValue.ApptType || 'R'
  //   };

  //   if (!shouldCreateNew && this.editingAppointmentId && this.editingRoleId) {
  //     appointmentPayload.RoleId = this.editingRoleId;
  //   }

  //   const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, {
  //     message: `Are you sure you want to assign/update the teacher(s) for this appointment?`,
  //     title: 'Confirm Save',
  //     icon: 'fa fa-question'
  //   });
  //   confirmDialog.afterClosed().subscribe(confirmed => {
  //     if (confirmed !== 'yes') return;
  //     this.isSaving = true;
  //     this.spinner.show();
  //     this.umsService.manageTeacherAppointments('SAVE_APPOINTMENT', appointmentPayload).subscribe({
  //       next: (res: any) => {
  //         this.spinner.hide();
  //         this.isSaving = false;
  //         if (res.status) {
  //           this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //             message: res.message || 'Teacher appointment saved successfully',
  //             title: 'Success',
  //             icon: 'fas fa-check-circle'
  //           });
  //           this.editingAppointmentId = null;
  //           this.editingRoleId = null;
  //           this.originalApptType = 'R';   
  //           this.TheoryExamForm.patchValue({ Teacher: '' });
  //           this.fetchAppointments();
  //         } else {
  //           this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //             message: res.message || 'Failed to save appointment',
  //             title: 'Error',
  //             icon: 'fas fa-exclamation-triangle'
  //           });
  //         }
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.spinner.hide();
  //         this.isSaving = false;
  //         this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //           message: error.error?.message || 'Error saving data',
  //           title: 'Error',
  //           icon: 'fas fa-exclamation-triangle'
  //         });
  //       }
  //     });
  //   });
  // }
 onSave() {
  if (this.isFinalSubmitted === true) {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: 'Cannot save. This schedule is already finalized.',
      title: 'Locked',
      icon: 'fas fa-lock'
    });
    return;
  }
  if (this.isSaving) return;

    const formValue = this.TheoryExamForm.value;

  if (!formValue.Teacher || !formValue.Role) {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: 'Please select Teacher and Role before saving.',
      title: 'Validation Error',
      icon: 'fas fa-exclamation-triangle'
    });
    return;
  }

  if (!formValue.FromDate || !formValue.ToDate) {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: 'Please select From Date and To Date.',
      title: 'Validation Error',
      icon: 'fas fa-exclamation-triangle'
    });
    return;
  }

  const fromDate = moment(formValue.FromDate);
  const toDate = moment(formValue.ToDate);
  if (fromDate.isAfter(toDate)) {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: 'From Date cannot be after To Date.',
      title: 'Date Validation',
      icon: 'fas fa-exclamation-triangle'
    });
    return;
  }

  let updatedAppointments = [...this.teacherAppointments];
  const selectedRole = formValue.Role;
  const selectedTeacher = formValue.Teacher;

  if (selectedRole === 'CO') {
    const existingCO = updatedAppointments.find(a => a.RoleCode === 'CO' && a.AppointmentId !== this.editingAppointmentId);
    if (existingCO) {
      // Show the existing appointment info in a detailed popup
      this.showExistingAppointmentWarning(existingCO, 'CO');
      return;
    }
  }
  if (selectedRole === 'CI') {
    const existingCI = updatedAppointments.find(a => a.RoleCode === 'CI' && a.AppointmentId !== this.editingAppointmentId);
    if (existingCI) {
      this.showExistingAppointmentWarning(existingCI, 'CI');
      return;
    }
  }

  let existingIndex = -1;
  if (selectedRole === 'CO' || selectedRole === 'CI') {
    existingIndex = updatedAppointments.findIndex(a => a.RoleCode === selectedRole);
  }
  if (selectedRole === 'INV' && this.editingRoleId) {
    existingIndex = updatedAppointments.findIndex(a => a.RoleId === this.editingRoleId);
  }
  if (existingIndex !== -1 && this.editingAppointmentId) {
    updatedAppointments[existingIndex] = {
      ...updatedAppointments[existingIndex],
      TechId: selectedTeacher,
      FromDate: formValue.FromDate,
      ToDate: formValue.ToDate
    };
  } else {
    updatedAppointments.push({
      RoleId: 0,
      RoleCode: selectedRole,
      TechId: selectedTeacher,
      FromDate: formValue.FromDate,
      ToDate: formValue.ToDate
    });
  }

  let facultyIdForSave = '';
  
  if (formValue.FacultyId && formValue.FacultyId.length > 0) {
    facultyIdForSave = formValue.FacultyId.join(',');
    console.log('📤 Using Faculty IDs from dropdown:', facultyIdForSave);
  } 
  else {
    const selectedCourses = formValue.Course || [];
    if (selectedCourses.length > 0) {
      const facultyCodeSet = new Set<string>();
      selectedCourses.forEach(courseCode => {
        const course = this.courseList.find(c => c.CoCgCoCode === courseCode);
        if (course && course.FcCode) {
          facultyCodeSet.add(course.FcCode);
        }
      });
      facultyIdForSave = Array.from(facultyCodeSet).join(',');
      console.log('📤 Using Faculty IDs from courses:', facultyIdForSave);
    }
  }

  console.log('📤 Final Faculty IDs for Save:', facultyIdForSave);
  console.log('📤 Selected Faculties from form:', formValue.FacultyId);
  console.log('📤 Selected Courses:', formValue.Course);

  const shouldCreateNew = this.editingAppointmentId
                            && this.originalApptType === 'R'
                            && formValue.ApptType === 'X';

    // Prepare CourseLevel as comma-separated string
    const selectedLevels = formValue.CourseLevel || [];
    const courseLevelString = selectedLevels.length > 0 ? selectedLevels.join(',') : null;

    const appointmentPayload: any = {
      AppointmentId: shouldCreateNew ? null : this.editingAppointmentId || null,
      TechId: formValue.Teacher,
      SessionId: formValue.SessionId,
      FacultyId: facultyIdForSave,
      CourseCode: formValue.Course.join(','),
      ExamId: formValue.Exam.join(','),
      CenterCode: formValue.Center,
      RoleCode: formValue.Role,
      FromDate: moment(formValue.FromDate).format('YYYY-MM-DD'),
      ToDate: moment(formValue.ToDate).format('YYYY-MM-DD'),
      CourseLevel: courseLevelString,
      ApptType: formValue.ApptType || 'R'
    };

    if (!shouldCreateNew && this.editingAppointmentId && this.editingRoleId) {
      appointmentPayload.RoleId = this.editingRoleId;
    }

    const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, {
      message: `Are you sure you want to assign/update the teacher(s) for this appointment?`,
      title: 'Confirm Save',
      icon: 'fa fa-question'
    });
    confirmDialog.afterClosed().subscribe(confirmed => {
      if (confirmed !== 'yes') return;
      this.isSaving = true;
      this.spinner.show();
      this.umsService.manageTeacherAppointments('SAVE_APPOINTMENT', appointmentPayload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.isSaving = false;
          if (res.status) {
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: res.message || 'Teacher appointment saved successfully',
              title: 'Success',
              icon: 'fas fa-check-circle'
            });
            this.editingAppointmentId = null;
            this.editingRoleId = null;
            this.originalApptType = 'R';   
            this.TheoryExamForm.patchValue({ Teacher: '' });
            this.fetchAppointments();
          } else {
            if (res.message && (res.message.includes('already appointed') || res.message.includes('Only one'))) {
              this.fetchAppointments();
              this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                message: res.message + '\nPlease check the existing appointment below.',
                title: 'Duplicate Role',
                icon: 'fas fa-exclamation-triangle'
              });
            } else {
              this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                message: res.message || 'Failed to save appointment',
                title: 'Error',
                icon: 'fas fa-exclamation-triangle'
              });
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.isSaving = false;
          const errorMsg = error.error?.message || error.message || '';
          if (errorMsg.includes('already appointed') || errorMsg.includes('Only one CO') || errorMsg.includes('Only one CI')) {
            this.fetchAppointments();
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: errorMsg + '\nPlease check the existing appointment in the table below.',
              title: 'Duplicate Role',
              icon: 'fas fa-exclamation-triangle'
            });
          } else {
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: errorMsg || 'Error saving data',
              title: 'Error',
              icon: 'fas fa-exclamation-triangle'
            });
          }
        }
      });
    });
  }

private showExistingAppointmentWarning(existingAppointment: any, roleCode: string) {
  const roleName = roleCode === 'CO' ? 'Center Observer' : 'Center Incharge';
  
  
  this.fetchAppointments();

  const message = 
`A ${roleName} is already appointed:

Teacher: ${existingAppointment.TeacherName || 'N/A'}
From Date: ${existingAppointment.FromDate || 'N/A'}
To Date: ${existingAppointment.ToDate || 'N/A'}
Center: ${existingAppointment.CenterName || 'N/A'}

Only one ${roleName} is allowed per center.
Please check the existing appointment in the table below.`;
  

  this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
    message: message,
    title: `Duplicate ${roleName}`,
    icon: 'fas fa-exclamation-triangle'

  });
}
  private setEditFormValues(item: any) {
    const fromDate = moment(item.FromDate, ['DD-MM-YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']);
    const toDate = moment(item.ToDate, ['DD-MM-YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']);

    const courseCodes = item.CourseCode ? item.CourseCode.split(',').map((c: string) => c.trim()) : [];
    const examIds = item.ExamId ? item.ExamId.split(',').map((id: string) => Number(id.trim())) : [];

    // FacultyId may be comma-separated
    const facultyIdArray = item.FacultyId ? item.FacultyId.split(',').map((f: string) => f.trim()) : [];

    // CourseLevel may be a single code or comma-separated; we'll convert to array
    let levelArray: string[] = [];
    if (item.CourseLevelCode) {
      levelArray = item.CourseLevelCode.split(',').map((l: string) => l.trim()).filter(l => l);
    }

    this.TheoryExamForm.patchValue({
      SessionId: item.SessionId,
      FacultyId: facultyIdArray,
      Course: courseCodes,
      Exam: examIds,
      Center: item.CenterCode,
      FromDate: fromDate.isValid() ? fromDate.format('YYYY-MM-DD') : '',
      ToDate: toDate.isValid() ? toDate.format('YYYY-MM-DD') : '',
      Role: item.RoleCode,
      CourseLevel: levelArray,   // set as array
      ApptType: item.ApptType || 'R'   
    }, { emitEvent: false });

    const formVal = this.TheoryExamForm.value;
    if (formVal.Center && formVal.Role) {
      this.loadTeachers((success) => {
        if (success) {
          const exists = this.filteredTeacherList.some(t => t.TechId === item.TechId);
          if (!exists) {
            const teacherObj = {
              TechId: item.TechId,
              displayName: item.TeacherName || `Teacher ${item.TechId}`,
              teacherName: item.TeacherName || `Teacher ${item.TechId}`,
              isAssigned: true,
            };
            this.filteredTeacherList.push(teacherObj);
            this.teacherList.push(teacherObj);
          }
          this.TheoryExamForm.patchValue({ Teacher: item.TechId }, { emitEvent: false });
        } else {
          this.TheoryExamForm.patchValue({ Teacher: item.TechId }, { emitEvent: false });
          console.warn('Failed to load teachers, but set teacher ID');
        }
        this.spinner.hide();
        this.showTeacherDropdown = true;
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'You can now edit the appointment and click Save to update.',
          title: 'Edit Mode',
          icon: 'fas fa-edit'
        });
      });
    } else {
      this.TheoryExamForm.patchValue({ Teacher: item.TechId }, { emitEvent: false });
      this.spinner.hide();
      this.showTeacherDropdown = true;
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'You can now edit the appointment and click Save to update.',
        title: 'Edit Mode',
        icon: 'fas fa-edit'
      });
    }
  }

  onEditAppointment(item: any, index: number) {
    if (item.IsFinalSubmit === 1 || this.isFinalSubmitted) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Cannot edit. This schedule is already finalized.',
        title: 'Locked',
        icon: 'fas fa-lock'
      });
      return;
    }

    this.editingAppointmentId = item.AppointmentId;
    this.editingRoleId = item.RoleId;
    this.originalApptType = item.ApptType || 'R';   

    const facultyCode = item.FacultyId;
    const sessionId = item.SessionId;
    const payload = { SessionId: sessionId, FcCode: facultyCode };

    this.spinner.show();

    this.umsService.getCoursesWithLevel(payload).subscribe({
      next: (courseRes) => {
        if (courseRes.status && courseRes.data && courseRes.data.length > 0) {
          this.courseList = courseRes.data;
          this.filteredCourseList = [...this.courseList];
        } else {
          this.courseList = [];
          this.filteredCourseList = [];
        }

        const courseCodes = item.CourseCode ? item.CourseCode.split(',').map((c: string) => c.trim()) : [];
        if (courseCodes.length > 0) {
          const examPayload = {
            EmCoCode: courseCodes.join(','),
            EmId: 0,
            CgCode: '',
            SearchString: '',
            PageSize: 1000,
            PageNumber: 1
          };
          this.umsService.getExam(examPayload).subscribe({
            next: (examRes) => {
              if (examRes.status && examRes.data && examRes.data.length > 0) {
                this.examList = examRes.data;
                this.filteredExamList = [...this.examList];
              } else {
                this.examList = [];
                this.filteredExamList = [];
              }
              this.setEditFormValues(item);
            },
            error: (err) => {
              this.examList = [];
              this.filteredExamList = [];
              this.setEditFormValues(item);
              console.error('Error fetching exams for edit:', err);
            }
          });
        } else {
          this.examList = [];
          this.filteredExamList = [];
          this.setEditFormValues(item);
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.courseList = [];
        this.filteredCourseList = [];
        this.examList = [];
        this.filteredExamList = [];
        this.setEditFormValues(item);
        console.error('Error fetching courses for edit:', err);
      }
    });
  }

  onDeleteAppointment(item: any, index: number) {
    if (this.isFinalSubmitted === true || item.IsFinalSubmit === 1) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Cannot delete. This schedule is already finalized.',
        title: 'Locked',
        icon: 'fas fa-lock'
      });
      return;
    }
    if (this.deletingInProgress) return;
    const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, {
      message: `Are you sure you want to delete the appointment for ${item.TeacherName} (${item.RoleName})?`,
      title: 'Confirm Delete',
      icon: 'fa fa-question'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result !== 'yes') return;
      this.spinner.show();
      this.deletingInProgress = true;
      this.umsService.manageTeacherAppointments('DELETE_APPOINTMENT', {
        AppointmentId: item.AppointmentId,
        RoleId: item.RoleId
      }).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.deletingInProgress = false;
          if (res.status) {
            this.fetchAppointments();
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: res.message || 'Role deleted successfully',
              title: 'Success',
              icon: 'fas fa-check-circle'
            });
          } else {
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: res.message || 'Failed to delete role',
              title: 'Error',
              icon: 'fas fa-exclamation-triangle'
            });
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.deletingInProgress = false;
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: err.error?.message || 'Error deleting role',
            title: 'Error',
            icon: 'fas fa-exclamation-triangle'
          });
        }
      });
    });
  }

  // onSendOrder(item: any, index: number) {
  //   if (this.isFinalSubmitted === true || item.IsFinalSubmit === 1) {
  //     this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //       message: 'Cannot send order. This schedule is already finalized.',
  //       title: 'Locked',
  //       icon: 'fas fa-lock'
  //     });
  //     return;
  //   }
  //   if (item.IsSendOrder === 1) {
  //     this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //       message: 'Order already sent for this role.',
  //       title: 'Information',
  //       icon: 'fas fa-info-circle'
  //     });
  //     return;
  //   }
  //   const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, {
  //     message: `Are you sure you want to send the appointment order to ${item.TeacherName} (${item.RoleName || item.RoleCode})?`,
  //     title: 'Confirm Send Order',
  //     icon: 'fa fa-question'
  //   });
  //   confirmDialog.afterClosed().subscribe(confirmed => {
  //     if (confirmed !== 'yes') return;
  //     this.spinner.show();
  //     const payload = {
  //       RoleId: item.RoleId,
  //       LoginId: parseInt(sessionStorage.getItem('userId') || '0')
  //     };
  //     this.umsService.sendOrder(payload).subscribe({
  //       next: (res: any) => {
  //         this.spinner.hide();
  //         if (res.status) {
  //           this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //             message: res.message || 'Order sent successfully!',
  //             title: 'Success',
  //             icon: 'fas fa-check-circle'
  //           });
  //           this.fetchAppointments();
  //         } else {
  //           this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //             message: res.message || 'Failed to send order',
  //             title: 'Error',
  //             icon: 'fas fa-exclamation-triangle'
  //           });
  //         }
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.spinner.hide();
  //         this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
  //           message: error.error?.message || 'Error sending order',
  //           title: 'Error',
  //           icon: 'fas fa-exclamation-triangle'
  //         });
  //       }
  //     });
  //   });
  // }
  onSendOrder(item: any, index: number) {
  // --- Validation ---
  if (this.isFinalSubmitted === true || item.IsFinalSubmit === 1) {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: 'Cannot send order. This schedule is already finalized.',
      title: 'Locked',
      icon: 'fas fa-lock'
    });
    return;
  }
  if (item.IsSendOrder === 1) {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: 'Order already sent for this role.',
      title: 'Information',
      icon: 'fas fa-info-circle'
    });
    return;
  }

  const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(
    ConformationModelComponent,
    {
      message: `Are you sure you want to send the appointment order to ${item.TeacherName} (${item.RoleName || item.RoleCode})? The appointment letter will be emailed to the teacher.`,
      title: 'Confirm Send Order',
      icon: 'fa fa-question'
    }
  );

  confirmDialog.afterClosed().subscribe(confirmed => {
    if (confirmed !== 'yes') return;

    this.spinner.show();

    const role = item.RoleCode;
    const loginId = parseInt(sessionStorage.getItem('userId') || '0');

    let reportPayload: any = { LoginId: loginId };

    // --- Build correct payload based on role ---
    if (role === 'CO') {
      reportPayload.ReportType = 'CO_LETTER';
      reportPayload.AppointmentId = item.AppointmentId;
      reportPayload.Extra1 = JSON.stringify({
        AppointmentId: item.AppointmentId,
        InCode: 1
      });
    } else if (role === 'CI') {
      reportPayload.ReportType = 'CI_LETTER';
      reportPayload.AppointmentId = item.AppointmentId;
      reportPayload.Extra1 = JSON.stringify({
        AppointmentId: item.AppointmentId,
        InCode: 2
      });
    } else if (role === 'C') {
      reportPayload.ReportType = 'C_LETTER';
      reportPayload.AppointmentId = item.AppointmentId;
      reportPayload.Extra1 = JSON.stringify({
        AppointmentId: item.AppointmentId,
        InCode: 4
      });
    } else if (role === 'INV') {
      // --- INV: find the CI appointment for the same center and session ---
      const centerCode = item.AptCent || item.CenterCode;
      const sessionId = item.SnNo || item.SessionId || this.TheoryExamForm.get('SessionId')?.value;
      if (!centerCode || !sessionId) {
        this.spinner.hide();
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'Missing center or session information for this INV appointment.',
          title: 'Error',
          icon: 'fas fa-exclamation-triangle'
        });
        return;
      }

      // Search in teacherAppointments for the CI role with same CenterCode and SessionId
      const ciAppointment = this.teacherAppointments.find(
        app => app.RoleCode === 'CI' &&
               (app.AptCent === centerCode || app.CenterCode === centerCode) &&
               (app.SnNo === sessionId || app.SessionId === sessionId)
      );

      if (!ciAppointment) {
        this.spinner.hide();
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'No CI appointment found for this center and session to generate the letter.\nPlease create a Center Incharge (CI) appointment first.',
          title: 'Error',
          icon: 'fas fa-exclamation-triangle'
        });
        return;
      }

      reportPayload.ReportType = 'CI_LETTER';
      reportPayload.AppointmentId = ciAppointment.AppointmentId;
      reportPayload.Extra1 = JSON.stringify({
        AppointmentId: ciAppointment.AppointmentId,
        InCode: 2
      });
    } else {
      this.spinner.hide();
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: `Unsupported role: ${role}`,
        title: 'Error',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    // --- Step 1: Generate PDF ---
    this.umsService.renderHbsReport(reportPayload).subscribe({
      next: (blob: Blob) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = (reader.result as string).split(',')[1];

          const teacherEmail = item.Email;
          if (!teacherEmail) {
            this.spinner.hide();
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: 'Teacher email not available. Please check appointment data.',
              title: 'Error',
              icon: 'fas fa-exclamation-triangle'
            });
            return;
          }

          // --- Get mobile number from item ---
          const mobileNumber = item.Mobile || item.MobileNo || '';
      
          const emailPayload = {
            from: 'examhelpdesk@muhs.ac.in',
            to: teacherEmail,
            subject: `Appointment Order – Theory Exam (${role})`,
            html: `
              <p>Dear ${item.TeacherName || 'Teacher'},</p>
              <p>Please find attached your appointment order for the role of (${role === 'C' ? 'Custodian' : role}) for the Theory Examination.</p>
              <p>Kindly refer to the attached PDF for your records.</p>
              <p>Thank you.</p>
            `,
            attachments: [{
              filename: `Appointment_Letter_${role}_${item.AppointmentId}.pdf`,
              content: base64String,
              encoding: 'base64',
              contentType: 'application/pdf'
            }],
            // NEW FIELDS FOR SMS
            module: 'COCI',
            // sms: {
            //   mobileNumber: mobileNumber,
            //   Extra1: JSON.stringify({
            //     username: mobileNumber,
            //     Password: 'MUHS',
            //     roleName: item.RoleName || role,
            //     roleCode: item.RoleCode || role
            //   })
            // }
          };

          // --- Step 2: Send email with new payload ---
          this.umsService.sendEmail(emailPayload).subscribe({
            next: (emailRes: any) => {
              // --- Step 3: Update IsSendOrder ---
              const updatePayload = {
                RoleId: item.RoleId,
                LoginId: loginId
              };
              this.umsService.manageTeacherAppointments('SEND_ORDER', updatePayload).subscribe({
                next: (updateRes: any) => {
                  this.spinner.hide();
                  if (updateRes.status) {
                    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                      message: updateRes.message || 'Appointment order sent successfully to teacher’s email and SMS!',
                      title: 'Success',
                      icon: 'fas fa-check-circle'
                    });
                    this.fetchAppointments();
                  } else {
                    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                      message: 'Email sent, but failed to update order status. Please contact support.',
                      title: 'Warning',
                      icon: 'fas fa-exclamation-triangle'
                    });
                  }
                },
                error: (updateErr) => {
                  this.spinner.hide();
                  console.error('Update SEND_ORDER error:', updateErr);
                  this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                    message: 'Email sent, but failed to update order status. Please contact support.',
                    title: 'Warning',
                    icon: 'fas fa-exclamation-triangle'
                  });
                }
              });
            },
            error: (emailErr) => {
              this.spinner.hide();
              console.error('Email send error:', emailErr);
              this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                message: emailErr.error?.error || 'Failed to send email. Please try again.',
                title: 'Error',
                icon: 'fas fa-exclamation-triangle'
              });
            }
          });
        };
        reader.onerror = () => {
          this.spinner.hide();
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: 'Failed to read PDF blob.',
            title: 'Error',
            icon: 'fas fa-exclamation-triangle'
          });
        };
        reader.readAsDataURL(blob);
      },
      error: (reportErr) => {
        this.spinner.hide();
        console.error('PDF generation error:', reportErr);
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'Failed to generate appointment letter. Please try again.',
          title: 'Error',
          icon: 'fas fa-exclamation-triangle'
        });
      }
    });
  });
}

  toggleSelection(item: any): void {
    const index = this.selectedAppointments.findIndex(sel => sel.RoleId === item.RoleId);
    if (index > -1) {
      this.selectedAppointments.splice(index, 1);
    } else {
      this.selectedAppointments.push(item);
    }
  }

  // Check if an item is selected
  isSelected(item: any): boolean {
    return this.selectedAppointments.some(sel => sel.RoleId === item.RoleId);
  }

  // Toggle select all / deselect all
  toggleSelectAll(event: any): void {
    const checked = event.target.checked;
    if (checked) {
      // Select only those that are not disabled (not finalized, not already sent)
      this.selectedAppointments = this.teacherAppointments.filter(
        item => !(this.isFinalSubmitted || item.IsFinalSubmit === 1 || item.IsSendOrder)
      );
    } else {
      this.selectedAppointments = [];
    }
  }

  // Check if all selectable items are selected
  isAllSelected(): boolean {
    const selectable = this.teacherAppointments.filter(
      item => !(this.isFinalSubmitted || item.IsFinalSubmit === 1 || item.IsSendOrder)
    );
    return selectable.length > 0 && this.selectedAppointments.length === selectable.length;
  }

  // Bulk send orders
  bulkSendOrders(): void {
    if (this.isProcessingBulk) return;
    if (this.selectedAppointments.length === 0) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'No appointments selected.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      });
      return;
    }

    // Confirm before sending
    const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(
      ConformationModelComponent,
      {
        message: `Are you sure you want to send orders to ${this.selectedAppointments.length} selected teacher(s)? Each will receive an email with the appointment letter and SMS notification.`,
        title: 'Confirm Bulk Send',
        icon: 'fa fa-question'
      }
    );

    confirmDialog.afterClosed().subscribe(confirmed => {
      if (confirmed !== 'yes') return;

      this.isProcessingBulk = true;
      this.spinner.show();

      let successCount = 0;
      let failCount = 0;
      const total = this.selectedAppointments.length;

      // Process sequentially to avoid overload
      this.processNextBulk(0, successCount, failCount, total);
    });
  }

  private processNextBulk(index: number, successCount: number, failCount: number, total: number): void {
    if (index >= total) {
      // All done
      this.spinner.hide();
      this.isProcessingBulk = false;
      this.selectedAppointments = [];
      this.fetchAppointments(); // refresh table

      const msg = `Appointment Letter Sent to the Teacher's Email Address: ${successCount} successful, ${failCount} failed.`;
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: msg,
        title: 'Bulk Send Summary',
        icon: successCount > 0 ? 'fas fa-check-circle' : 'fas fa-exclamation-triangle'
      });
      return;
    }

    const item = this.selectedAppointments[index];
    // Call the same logic as onSendOrder but without the confirmation dialog
    this.sendSingleOrder(item, (success) => {
      if (success) successCount++;
      else failCount++;
      // Move to next
      this.processNextBulk(index + 1, successCount, failCount, total);
    });
  }

  // Helper: send a single order (no confirmation dialog)
  private sendSingleOrder(item: any, callback: (success: boolean) => void): void {
    const role = item.RoleCode;
    const loginId = parseInt(sessionStorage.getItem('userId') || '0');

    let reportPayload: any = { LoginId: loginId };

    if (role === 'CO') {
      reportPayload.ReportType = 'CO_LETTER';
      reportPayload.AppointmentId = item.AppointmentId;
      reportPayload.Extra1 = JSON.stringify({ AppointmentId: item.AppointmentId, InCode: 1 });
    } else if (role === 'CI') {
      reportPayload.ReportType = 'CI_LETTER';
      reportPayload.AppointmentId = item.AppointmentId;
      reportPayload.Extra1 = JSON.stringify({ AppointmentId: item.AppointmentId, InCode: 2 });
    } else if (role === 'C') {
      reportPayload.ReportType = 'C_LETTER';
      reportPayload.AppointmentId = item.AppointmentId;
      reportPayload.Extra1 = JSON.stringify({ AppointmentId: item.AppointmentId, InCode: 4 });
    } else if (role === 'INV') {
      // --- INV: find CI appointment ---
      const centerCode = item.AptCent || item.CenterCode;
      const sessionId = item.SnNo || item.SessionId || this.TheoryExamForm.get('SessionId')?.value;
      if (!centerCode || !sessionId) {
        callback(false);
        return;
      }
      const ciAppointment = this.teacherAppointments.find(
        app => app.RoleCode === 'CI' &&
               (app.AptCent === centerCode || app.CenterCode === centerCode) &&
               (app.SnNo === sessionId || app.SessionId === sessionId)
      );
      if (!ciAppointment) {
        callback(false);
        return;
      }
      reportPayload.ReportType = 'CI_LETTER';
      reportPayload.AppointmentId = ciAppointment.AppointmentId;
      reportPayload.Extra1 = JSON.stringify({ AppointmentId: ciAppointment.AppointmentId, InCode: 2 });
    } else {
      callback(false);
      return;
    }

    // 1. Generate PDF
    this.umsService.renderHbsReport(reportPayload).subscribe({
      next: (blob: Blob) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = (reader.result as string).split(',')[1];
          const teacherEmail = item.Email;
          if (!teacherEmail) {
            callback(false);
            return;
          }

          const mobileNumber = item.Mobile || item.MobileNo || '';

          const emailPayload = {
            from: 'examhelpdesk@muhs.ac.in',
            to: teacherEmail,
            subject: `Appointment Order – Theory Exam (${role === 'C' ? 'Custodian' : role})`,
            html: `
              <p>Dear ${item.TeacherName || 'Teacher'},</p>
              <p>Please find attached your appointment order for the role of (${role === 'C' ? 'Custodian' : role}) for the Theory Examination.</p>
              <p>Kindly refer to the attached PDF for your records.</p>
              <p>Thank you.</p>
            `,
            attachments: [{
              filename: `Appointment_Letter_${role}_${item.AppointmentId}.pdf`,
              content: base64String,
              encoding: 'base64',
              contentType: 'application/pdf'
            }],
            // NEW FIELDS FOR SMS
            module: 'COCI',
            // sms: {
            //   mobileNumber: mobileNumber,
            //   Extra1: JSON.stringify({
            //     username: mobileNumber,
            //     Password: 'MUHS',
            //     roleName: item.RoleName || role,
            //     roleCode: item.RoleCode || role
            //   })
            // }
          };

          // 2. Send email
          this.umsService.sendEmail(emailPayload).subscribe({
            next: () => {
              // 3. Update IsSendOrder
              const updatePayload = { RoleId: item.RoleId, LoginId: loginId };
              this.umsService.manageTeacherAppointments('SEND_ORDER', updatePayload).subscribe({
                next: (updateRes: any) => {
                  if (updateRes.status) {
                    callback(true);
                  } else {
                    callback(false);
                  }
                },
                error: () => callback(false)
              });
            },
            error: () => callback(false)
          });
        };
        reader.onerror = () => callback(false);
        reader.readAsDataURL(blob);
      },
      error: () => callback(false)
    });
  }

  onFinalSubmit() {
    if (this.isFinalSubmitted) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'This appointment is already finalized!',
        title: 'Already Submitted',
        icon: 'fas fa-lock'
      });
      return;
    }

    if (this.teacherAppointments.length === 0) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'No appointments to submit. Please add at least one teacher appointment.',
        title: 'Cannot Submit',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    const coCount = this.teacherAppointments.filter(a => a.RoleCode === 'CO').length;
    const ciCount = this.teacherAppointments.filter(a => a.RoleCode === 'CI').length;
    const invCount = this.teacherAppointments.filter(a => a.RoleCode === 'INV').length;
    const custodianCount = this.teacherAppointments.filter(a => a.RoleCode === 'C').length;  // new check

    if (coCount !== 1) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: `Exactly 1 Center Observer (CO) is required. Currently selected: ${coCount} CO.`,
        title: 'Validation Failed',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    if (ciCount !== 1) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: `Exactly 1 Center Incharge (CI) is required. Currently selected: ${ciCount} CI.`,
        title: 'Validation Failed',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    if (invCount < 1) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: `At least 1 Internal Vigilance Squad (IVS) is required. Currently selected: ${invCount} IVS.`,
        title: 'Validation Failed',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    if (custodianCount < 1) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: `At least 1 Custodian (C) is required. Currently selected: ${custodianCount}.`,
        title: 'Validation Failed',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, {
      message: `Are you sure you want to finalize this appointment schedule with ${this.teacherAppointments.length} teacher(s)? (CO: ${coCount}, CI: ${ciCount}, IVS: ${invCount}, Custodian: ${custodianCount})\nAfter final submission, you cannot add, edit, or delete any appointments.`,
      title: 'Confirm Final Submission',
      icon: 'fa fa-question'
    });

    confirmDialog.afterClosed().subscribe((confirmed) => {
      if (confirmed !== 'yes') return;

      this.spinner.show();

      const formValue2 = this.TheoryExamForm.value;
      const submissionPayload = {
        SessionId: formValue2.SessionId,
        CourseCode: formValue2.Course.join(','),      
        ExamId: formValue2.Exam.join(','),            
        CenterCode: formValue2.Center,
        LoginId: parseInt(sessionStorage.getItem('userId') || '0')
      };

      this.umsService.finalSubmitAppointment(submissionPayload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res.status) {
            this.isFinalSubmitted = true;
            this.disableFormAfterFinalSubmit();
            this.teacherList = [];
            this.filteredTeacherList = [];
            this.fetchAppointments();
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: res.message || 'Appointment schedule finalized successfully!',
              title: 'Success',
              icon: 'fas fa-check-circle'
            });
          } else {
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: res.message || 'Failed to finalize submission',
              title: 'Error',
              icon: 'fas fa-exclamation-triangle'
            });
          }
        },
        error: (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: error.error?.message || 'Error finalizing submission',
            title: 'Error',
            icon: 'fas fa-exclamation-triangle'
          });
        }
      });
    });
  }

  getRoleName(roleCode: string): string {
    const role = this.roleList.find(r => r.CdCode === roleCode);
    return role ? role.CdDesc : roleCode;
  }

  // ========== FIXED onList() METHOD ==========
  onList() {
    console.log('📋 onList() called');
    console.log('📋 teacherAppointments:', this.teacherAppointments);
    console.log('📋 Table state before:', this.Table);
    
    if (this.teacherAppointments.length === 0) {
      // Try to fetch appointments if none exist
      this.fetchAppointments();
      
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'No appointments to display. Please search first.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      });
    } else {
      // SHOW THE TABLE by setting Table = true
      this.Table = true;
      
      // Show the popup with count
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: `Total ${this.teacherAppointments.length} appointments found.`,
        title: 'List Information',
        icon: 'fas fa-list'
      });
      
      console.log('📋 Table state after:', this.Table);
    }
  }

  onDownload() {
  if (!this.Table || this.teacherAppointments.length === 0) {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: 'No data available to download.',
      title: 'Information',
      icon: 'fas fa-info-circle'
    });
    return;
  }
  
  const headers = ['S.No', 'Teacher Name', 'Role', 'From Date', 'To Date', 'Session', 'Faculty', 'Course', 'Exam', 'Center', 'Appointment Type'];
  
  const rows = this.teacherAppointments.map((item, index) => {
    let fromDate = item.FromDate, toDate = item.ToDate;
    if (fromDate === '-' && item.rawFromDate) fromDate = item.rawFromDate;
    if (toDate === '-' && item.rawToDate) toDate = item.rawToDate;
    
    let roleDisplay = '';
    if (item.RoleCode === 'INV') {
      const squad = this.getSquadNumber(item.TechId);
      roleDisplay = squad ? `Internal Vigilance Squad-${squad}` : (item.RoleName || item.RoleCode);
    } else {
      roleDisplay = item.RoleName || item.RoleCode;
    }
    
    // Determine Appointment Type display value
    let appointmentTypeDisplay = '-';
    if (item.ApptType === 'R') {
      appointmentTypeDisplay = 'Regular';
    } else if (item.ApptType === 'X') {
      appointmentTypeDisplay = 'Emergency Replacement';
    } else if (item.ApptType) {
      appointmentTypeDisplay = item.ApptType;
    }
    
    return [
      index + 1,
      (item.TeacherName || '').trim().replace(/\s+/g, ' '),
      roleDisplay,
      this.formatDateForExcel(fromDate),
      this.formatDateForExcel(toDate),
      item.SessionName || '',
      item.FacultyName || '',
      item.CourseName || '',
      item.ExamName || '',
      item.CenterName || '',
      appointmentTypeDisplay
    ];
  });
  
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => {
      if (typeof cell === 'string' && (cell.includes(',') || cell.includes('"'))) {
        return `"${cell.replace(/"/g, '""')}"`;
      }
      return cell;
    }).join(','))
  ].join('\n');
  
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = `Teacher_Appointments_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

  formatDateForExcel(dateValue: any): string {
    if (!dateValue || dateValue === '-' || dateValue === '') return '';
    if (typeof dateValue === 'string' && dateValue.includes('/')) return dateValue;
    const date = moment(dateValue);
    if (date.isValid()) return date.format('DD/MM/YYYY');
    if (typeof dateValue === 'string' && dateValue.includes('-')) {
      const parts = dateValue.split('-');
      if (parts.length === 3) return `${parts[0]}/${parts[1]}/${parts[2]}`;
    }
    return '';
  }

  onClear() {
    this.TheoryExamForm.reset();
    this.isFinalSubmitted = false;
    this.enableFormControls();
    this.TheoryExamForm.patchValue({
      FromDate: moment().format('YYYY-MM-DD'),
      ToDate: moment().format('YYYY-MM-DD'),
      Course: [],
      Exam: [],
      CourseLevel: [],        // reset to empty array
      ApptType: 'R',
      FacultyId: []
    });
    this.Table = false;
    this.teacherAppointments = [];
    this.editingAppointmentId = null;
    this.editingRoleId = null;
    this.originalApptType = 'R';   
    this.facultyList = [];
    this.filteredFacultyList = [];
    this.courseList = [];
    this.filteredCourseList = [];
    this.examList = [];
    this.filteredExamList = [];
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.teacherList = [];
    this.filteredTeacherList = [];
    this.isDateManuallyChanged = false;
    this.minExamDate = null;
    this.maxExamDate = null;
    this.teachersCache.clear();
    this.isLoadingTeachers = false;
    this.isFetchingAppointments = false;
    this.invigilatorSquadMap.clear();
    this.selectedInvigilators.clear();
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: 'Form cleared successfully',
      title: 'Success',
      icon: 'fas fa-check'
    });
  }

  checkFinalSubmissionStatus() {
    const formValue = this.TheoryExamForm.value;
    if (formValue.SessionId && formValue.Course && formValue.Exam && formValue.Center) {
      const payload = {
        SessionId: formValue.SessionId,
        CourseCode: formValue.Course.join(','),
        ExamId: formValue.Exam.join(','),
        CenterCode: formValue.Center,
        RoleCode: ''
      };
      this.umsService.getTeacherAppointments(payload).subscribe({
        next: (res: any) => {
          if (res.status && res.data && res.data.length > 0) {
            this.isFinalSubmitted = res.data.some((item: any) => item.IsFinalSubmit === true || item.IsFinalSubmit === 1);
            if (this.isFinalSubmitted) {
              this.disableFormAfterFinalSubmit();
              this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
                message: 'This schedule is already finalized. Only deletions are allowed.',
                title: 'Finalized',
                icon: 'fas fa-lock'
              });
            }
          } else {
            this.isFinalSubmitted = false;
          }
        },
        error: (err) => {
          console.error('Error checking final submission status:', err);
          this.isFinalSubmitted = false;
        }
      });
    }
  }

  disableFormAfterFinalSubmit() {
    this.isFinalSubmitted = true;
    this.TheoryExamForm.get('SessionId')?.disable();
    this.TheoryExamForm.get('FacultyId')?.disable();
    this.TheoryExamForm.get('Course')?.disable();
    this.TheoryExamForm.get('Exam')?.disable();
    this.TheoryExamForm.get('Center')?.disable();
    this.TheoryExamForm.get('FromDate')?.disable();
    this.TheoryExamForm.get('ToDate')?.disable();
    this.TheoryExamForm.get('Role')?.disable();
    this.TheoryExamForm.get('Teacher')?.disable();
  }

  enableFormControls() {
    this.isFinalSubmitted = false;
    this.TheoryExamForm.get('SessionId')?.enable();
    this.TheoryExamForm.get('FacultyId')?.enable();
    this.TheoryExamForm.get('Course')?.enable();
    this.TheoryExamForm.get('Exam')?.enable();
    this.TheoryExamForm.get('Center')?.enable();
    this.TheoryExamForm.get('FromDate')?.enable();
    this.TheoryExamForm.get('ToDate')?.enable();
    this.TheoryExamForm.get('Role')?.enable();
    this.TheoryExamForm.get('Teacher')?.enable();
  }

  get f() { return this.TheoryExamForm.controls; }
}